var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality"
    },
    viewBox: "0 0 260 260",
    x: "0px",
    y: "0px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M63 242c-11,25 -63,22 -63,-10l0 -127c0,-27 50,-30 62,-10 23,-11 49,-28 46,-57 -6,-54 41,-48 56,3 6,19 3,33 -3,50l73 0c29,0 34,35 15,47 11,12 7,34 -9,43 9,12 3,36 -11,42 6,14 -2,34 -29,36 -45,2 -95,1 -137,-17zm-31 -26c6,0 10,4 10,10 0,5 -4,10 -10,10 -5,0 -9,-5 -9,-10 0,-6 4,-10 9,-10zm33 16c40,18 90,19 135,17 27,-1 26,-27 10,-27 -5,0 -9,0 -14,0 -5,0 -7,-6 0,-6 9,0 17,0 25,0 13,-2 22,-34 0,-34 -5,0 -12,0 -17,0 -7,0 -7,-8 0,-8 7,0 15,0 22,0 22,0 28,-33 4,-33l-19 0c-7,0 -7,-8 0,-8 8,0 15,0 23,0 22,-1 22,-32 0,-33l-87 0c8,-21 15,-35 8,-56 -12,-38 -42,-49 -37,-7 3,34 -24,54 -53,68l0 127z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGood);
export default __webpack_public_path__ + "static/media/good.185ae04b4c9bd71c5063e25a2d4f3dc5.svg";
export { ForwardRef as ReactComponent };